/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SeoLink_linkData = {
    readonly path: string | null;
    readonly isLinkable: boolean | null;
    readonly " $refType": "SeoLink_linkData";
};
export type SeoLink_linkData$data = SeoLink_linkData;
export type SeoLink_linkData$key = {
    readonly " $data"?: SeoLink_linkData$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeoLink_linkData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};
(node as any).hash = '55a81d229ac5e2ca87225e8d0dbdd2a0';
export default node;
